import request from '../../utils/request'

const preFix = '/index/statistics';

export const reqPersonStatistics = () => {
    return request({
        url: preFix + '/personStatistics',
        method: 'get',
    })
}
export const reqOrderTurnoverStatistics = (params) => {
    return request({
        url: preFix + '/turnover',
        method: 'get',
        params
    })
}
